<template>
  <el-dialog
    width="620px"
    title="充值详情"
    append-to-body
    :visible.sync="dialogVisible"
  >
    <!-- footer -->
    <template v-slot:footer>
      <el-row type="flex" justify="center">
        <el-button @click="handleCancel">关闭</el-button>
      </el-row>
    </template>

    <!-- body -->
    <zf-table
      :columns="columns"
      :data-source="tableData"
      :pagination="false"
    />
  </el-dialog>
</template>

<script>
import ZfTable from '@/components/ZfTable/CoreTable'

export default {
  name: 'RechageDetail',
  components: {
    ZfTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: [
        {
          prop: 'mch_id',
          label: '商户号'
        },
        {
          prop: 'price',
          label: '充值金额'
        }
      ]
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    tableData() {
      return this.list.map((item, i) => {
        return {
          mch_id: item.mch_id,
          price: '￥' + item.price
        }
      })
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    }
  }
}
</script>
